import React, { useState } from 'react';
import {
    GetAllLofasFiltered_getAllLofasFiltered as Lofa,
    GetAllRegions_getAllRegions as RegionType
} from '../../../types/schemaTypes';
import './LofaItem.scss';
import DeleteModal from '../../../components/JobProfile/DeleteModal';

interface Option {
    id: number | string;
    name: string | number;
}

interface LofaItemProps {
    lofa: Lofa;
    regionsWithDistricts: RegionType[];
    index: number;
    canEditLofas: boolean;
    onEditClick: (lofa: Lofa) => void;
    onDelete?: (record: any) => void;
    onCLickLofa: (lat: number, lng: number, lofaName: string) => void;
}

const LofaItem = ({
    lofa,
    regionsWithDistricts,
    index,
    onEditClick,
    onDelete,
    canEditLofas,
    onCLickLofa,
}: LofaItemProps): React.ReactElement => {
    const isOdd = index % 2 == 1;
    const containerStyle = `LofasItem-Bottom-Container ${!isOdd && 'LofasItem-Bottom-Container-With-Background'}`;

    const { lofaName, addressStreet, city, regionId, districtId, zip, phoneNumber, jdeNumber, latitude, longitude } = lofa;
    const [deleteConfirm, setDeleteConfirm] = useState(false);

    const handleDelete = () => {
        onDelete && onDelete(lofa);
        setDeleteConfirm(false);
    };

    const regionWithDistricts = regionsWithDistricts.find(region => region.id === regionId);
    const region = regionWithDistricts?.regionName ?? '';
    const district = regionWithDistricts?.districts?.find(district => district?.id === districtId)?.districtName ?? '';

    return (
        <div className={containerStyle}>
            <div
                className="LofasItem-List-Header-Link"
                onClick={(): void => onCLickLofa(latitude!, longitude!, lofaName!)}
            >
                {lofaName}
            </div>
            <div className="LofasItem-List-Header-Lg">{addressStreet}</div>
            <div className="LofasItem-List-Header">{city}</div>
            <div className="LofasItem-List-Header">{region}</div>
            <div className="LofasItem-List-Header">{district}</div>
            <div className="LofasItem-List-Header-Sm">{zip}</div>
            <div className="LofasItem-List-Header">{jdeNumber}</div>
            {!canEditLofas && <div className="GridViewItem-List-Header"></div>}
            {canEditLofas && (
                <div className="GridViewItem-List-Header">
                    {canEditLofas && (
                        <div
                            className={` ${canEditLofas ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                                }`}
                            onClick={() => onEditClick(lofa)}
                        >
                            <i className="material-icons UsersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )}
                    &nbsp;|&nbsp;
                    {canEditLofas && onDelete && (
                        <div onClick={() => setDeleteConfirm(true)} className={` ${'GridViewItem-Edit-Container'}`}>
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Delete</span>
                        </div>
                    )}
                </div>
            )}

            <DeleteModal
                show={deleteConfirm}
                name={'lofa'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default LofaItem;

